export default __webpack_public_path__ + "static/media/signUp.50b89624.png";